import store from "../redux/store";
import {enqueueSnackbar} from "../redux/actions/snackbarActions";
import {errorMessage} from "./alertMessages";
import {AuthService} from "./AuthService";
import {redirectTo} from "../routes/functions";

export function handleError(error, message) {
  const errorMessages = [
    "Failed in authentication",
    "Bad permissions",
    "Invalid token",
    "Expired token"
  ];
  
  // Check for HTTP 403 status code or authentication error messages
  const isAuthError = error?.response?.status === 403 || 
    (error?.response?.data?.message && errorMessages.some(msg => error.response.data.message.includes(msg)));
  
  if (isAuthError) {
      AuthService.logout();
      redirectTo('/auth/sign-in')
      store.dispatch(enqueueSnackbar(errorMessage("Failed in authentication. Please Logout")))
      return true; // Indicate that execution should stop
    }
    else if(error?.response?.data?.message && error.response.data.message.includes("Access denied")){
      store.dispatch(enqueueSnackbar(errorMessage("Access Denied")))
      return true; // Indicate that execution should stop
    }
    else{
      store.dispatch(enqueueSnackbar(errorMessage(error?.response?.data?.message || message)))
      return false; // Indicate that execution can continue
    }
}